import { Areas } from '@thive/fddm-types';

import { Area } from '@modules/floorplanDesign/types';
import { FloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { areasToFlatCollection } from '@/modules/floorplanDesign/helpers/helpers';
import { isHighwayArea } from '@/modules/floorplanDesign/helpers/typeguards';

import { Collision } from '../types';

export const getAreasFromCollisions = (
  collisions: Collision[],
  getAreaByAreaIdOrSegmentId: FloorplanDesignStore['getAreaByAreaIdOrSegmentId'],
): Area[] =>
  collisions.flatMap((collision) => {
    const areaA = getAreaByAreaIdOrSegmentId(collision.idA);
    const areaB = getAreaByAreaIdOrSegmentId(collision.idB);
    return [areaA, areaB].filter((area): area is Area => area !== undefined);
  });

export const getAreasFromPersistedCollisions = (
  areas: Areas,
  collisionState: Map<string, string[]>,
  areasFromNewCollisions: Area[],
  getAreaByAreaIdOrSegmentId: FloorplanDesignStore['getAreaByAreaIdOrSegmentId'],
): Area[] =>
  areasToFlatCollection(areas).flatMap((updatedArea) => {
    const fromIds = isHighwayArea(updatedArea)
      ? updatedArea.segments.map((s) => s.id)
      : [updatedArea.id];
    const otherIds = fromIds.flatMap((fromId) => collisionState.get(fromId) ?? []);

    return otherIds.flatMap((toId) => {
      const area = getAreaByAreaIdOrSegmentId(toId);
      if (!area || areasFromNewCollisions.includes(area)) return [];
      return area;
    });
  });
